import { getSourceListApi } from '@/api/common/source'
import {
  getAccount,
  getAgent,
  getBookingGroup,
  getDebitAccByAgent,
  getListNation,
  getMarketSeg,
  getPriceCode,
  getRoom,
  // getRoomLevel,
  getRoomLevelbyHotel,
  getRoomProperty,
  getSpecialService
} from '@/api/reception/common'
import { Message } from 'element-ui'

// call common api
// arrival guest menu
export async function callGetMarketSeg() {
  let res = null
  try {
    res = await getMarketSeg()
    if (res.is_error) {
      throw new Error(res)
    }
  } catch (error) {
    console.log(error)
    Message({
      message: 'Lỗi lấy dữ liệu!',
      type: 'error'
    })
  } finally {
    //
  }
  return (
    res?.data.map(item => ({
      ...item,
      name: item.desc
    })) || []
  )
}

export async function callGetAgent() {
  let res = null
  try {
    res = await getAgent()
    if (res.is_error) {
      throw new Error(res)
    }
  } catch (error) {
    console.log(error)
    Message({
      message: 'Lỗi lấy dữ liệu!',
      type: 'error'
    })
  } finally {
    //
  }
  return res?.data || []
}

export async function getAllSource() {
  let res = null
  try {
    res = await getSourceListApi({ isActive: 1 })
    if (res.is_error) {
      throw new Error(res)
    }
  } catch (error) {
    console.log(error)
    Message({
      message: 'Lỗi lấy dữ liệu!',
      type: 'error'
    })
  } finally {
    //
  }
  return (
    res?.data ||
    [].map(item => ({
      ...item,
      id: item.id,
      code: item.code,
      desc: item.desc
    }))
  )
}

export async function callGetDebitAccByAgent(query) {
  let res = null
  try {
    res = await getDebitAccByAgent(query)
    if (res.is_error) {
      throw new Error(res)
    }
  } catch (error) {
    console.log(error)
    Message({
      message: 'Lỗi lấy dữ liệu!',
      type: 'error'
    })
  } finally {
    //
  }
  return res?.data || []
}

export async function callGetBookingGroup(query = {}) {
  let res = null
  try {
    res = await getBookingGroup(query)
    if (res.is_error) {
      throw new Error(res)
    }
  } catch (error) {
    console.log(error)
    Message({
      message: 'Lỗi lấy dữ liệu!',
      type: 'error'
    })
  } finally {
    //
  }
  return res?.data || []
}

export async function callGetRoomLevel(params = {}) {
  let res = null
  try {
    res = await getRoomLevelbyHotel(params)
    if (res.is_error) {
      throw new Error(res)
    }
  } catch (error) {
    console.log(error)
    Message({
      message: 'Lỗi lấy dữ liệu!',
      type: 'error'
    })
  } finally {
    //
  }
  return res?.data || []
}

export async function callGetRoom() {
  let res = null
  try {
    res = await getRoom()
    if (res.is_error) {
      throw new Error(res)
    }
  } catch (error) {
    console.log(error)
    Message({
      message: 'Lỗi lấy dữ liệu!',
      type: 'error'
    })
  } finally {
    //
  }
  return (
    res?.data.map(item => ({
      id: item.id,
      code: item.key_code,
      name: item.key_code
    })) || []
  )
}

export async function callGetAccount() {
  let res = null
  try {
    res = await getAccount()
    if (res.is_error) {
      throw new Error(res)
    }
  } catch (error) {
    console.log(error)
    Message({
      message: 'Lỗi lấy dữ liệu!',
      type: 'error'
    })
  } finally {
    //
  }
  return (
    res?.data.map(item => ({
      id: item.account.id,
      code: item.account.username,
      name: item.account.full_name
    })) || []
  )
}

export async function callGetPriceCode() {
  let res = null
  try {
    res = await getPriceCode()
    if (res.is_error) {
      throw new Error(res)
    }
  } catch (error) {
    console.log(error)
    Message({
      message: 'Lỗi lấy dữ liệu!',
      type: 'error'
    })
  } finally {
    //
  }
  return (
    res?.data.map(item => ({
      ...item,
      name: item.desc
    })) || []
  )
}

export async function callGetNation() {
  let res = null
  try {
    res = await getListNation()
    if (res.is_error) {
      throw new Error(res)
    }
  } catch (error) {
    console.log(error)
    Message({
      message: 'Lỗi lấy dữ liệu!',
      type: 'error'
    })
  } finally {
    //
  }
  return (
    res?.data.map(item => ({
      id: item.id,
      code: item.code,
      name: item.desc
    })) || []
  )
}

// room status menu
export async function callGetRoomProperty() {
  let res = null
  try {
    res = await getRoomProperty()
    if (res.is_error) {
      throw new Error(res)
    }
  } catch (error) {
    console.log(error)
    Message({
      message: 'Lỗi lấy dữ liệu!',
      type: 'error'
    })
  } finally {
    //
  }
  return (
    res?.data.map(item => ({
      id: item.id,
      code: item.code,
      name: item.description
    })) || []
  )
}

// room availability menu
export async function callGetSpecialService() {
  let res = null
  try {
    res = await getSpecialService()
    if (res.is_error) {
      throw new Error(res)
    }
  } catch (error) {
    console.log(error)
    Message({
      message: 'Lỗi lấy dữ liệu!',
      type: 'error'
    })
  } finally {
    //
  }
  return (
    res?.data.map(item => ({
      id: item.id,
      code: item.code,
      name: item.description
    })) || []
  )
}
